document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-asb-upload]');
  if (!root) return;

  var zone = root.querySelector('[data-asb-upload-zone]');
  var fileInput = root.querySelector('[data-asb-upload-input]');
  var statusEl = root.querySelector('[data-asb-upload-status]');
  var preview = root.querySelector('[data-asb-upload-preview]');
  var previewImage = root.querySelector('[data-asb-upload-image]');
  var previewFilename = root.querySelector('[data-asb-upload-filename-label]');
  var removeBtn = root.querySelector('[data-asb-upload-remove]');
  var urlInput = root.querySelector('[data-asb-logo-url]');
  var nameInput = root.querySelector('[data-asb-logo-filename]');

  if (!zone || !fileInput) return;

  zone.addEventListener('click', function () {
    fileInput.click();
  });

  zone.addEventListener('dragover', function (e) {
    e.preventDefault();
    e.stopPropagation();
    zone.classList.add('asb-upload-zone--over');
  });

  zone.addEventListener('dragleave', function (e) {
    e.preventDefault();
    e.stopPropagation();
    zone.classList.remove('asb-upload-zone--over');
  });

  zone.addEventListener('drop', function (e) {
    e.preventDefault();
    e.stopPropagation();
    zone.classList.remove('asb-upload-zone--over');
    if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
  });

  fileInput.addEventListener('change', function () {
    if (fileInput.files[0]) handleFile(fileInput.files[0]);
  });

  if (removeBtn) {
    removeBtn.addEventListener('click', function () {
      fileInput.value = '';
      if (urlInput) urlInput.value = '';
      if (nameInput) nameInput.value = '';
      if (preview) preview.classList.add('hidden');
      zone.classList.remove('hidden');
      if (statusEl) statusEl.classList.add('hidden');
    });
  }

  function handleFile(file) {
    if (file.size > 10 * 1024 * 1024) {
      showStatus('File too large. Maximum size is 10MB.', 'error');
      return;
    }

    var validTypes = ['image/jpeg', 'image/png', 'image/svg+xml', 'application/pdf'];
    if (validTypes.indexOf(file.type) === -1) {
      showStatus('Invalid file type. Please upload PNG, JPG, PDF, or SVG.', 'error');
      return;
    }

    showStatus('Uploading your logo...', 'loading');
    zone.style.pointerEvents = 'none';

    var formData = new FormData();
    formData.append('file', file);
    formData.append('folder', 'acrylic-scan-to-book-signs');

    fetch('https://wisetap-image-uploader-to-s3.vercel.app/api/upload', {
      method: 'POST',
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data.url) throw new Error((data.error && data.error.message) || 'Upload failed');
        if (urlInput) urlInput.value = data.url;
        if (nameInput) nameInput.value = file.name;
        if (previewImage) previewImage.src = data.url;
        if (previewFilename) previewFilename.textContent = file.name;
        if (preview) preview.classList.remove('hidden');
        zone.classList.add('hidden');
        showStatus('Upload successful!', 'success');
        setTimeout(function () {
          if (statusEl) statusEl.classList.add('hidden');
        }, 2000);
      })
      .catch(function (error) {
        console.error('Upload error:', error);
        showStatus('Upload failed. Please try again.', 'error');
      })
      .finally(function () {
        zone.style.pointerEvents = 'auto';
      });
  }

  function showStatus(message, type) {
    if (!statusEl) return;
    statusEl.innerHTML =
      '<span class="asb-upload-status-pill asb-upload-status-pill--' +
      type +
      ' kanit-semibold">' +
      message +
      '</span>';
    statusEl.classList.remove('hidden');
    if (type === 'error') {
      setTimeout(function () {
        statusEl.classList.add('hidden');
      }, 4000);
    }
  }
});
